import { defineStore } from 'pinia'
import { apiService } from '@/services/api'
import { formatDateTime } from '@/components/logics/dateUtil'

export const useInfoStore = defineStore('info', {
  state: () => ({
    infos: [],
    formData: null,
    tableList: [],
    tableInit: {
      id: null,
      title: '',
      text: '',
      startAt: '',
      endAt: '',
      lastEditor: '',
    },
  }),
  actions: {
    // 契約IDを設定
    setContractId(id) {
      this.contractId = id
    },

    // お知らせ一覧を取得
    async getInfos() {
      this.loading = true
      try {
        const response = await apiService.get(`/api/infos`)
        this.infos = response.infos
      } catch (error) {}
    },

    // テーブル表示用のリストを初期化
    initTableList() {
      this.tableList = [
        { label: 'No', key: 'rowNumber', data: (item, value) => value },
        { label: '表示開始', key: 'startAt', data: (item, value) => formatDateTime(value) },
        { label: '表示終了', key: 'endAt', data: (item, value) => formatDateTime(value) },
        { label: 'タイトル', key: 'title', data: (item, value) => value },
        {
          label: '内容',
          key: 'text',
          data: (item, value) => {
            return value.length > 20 ? value.substring(0, 20) + '...' : value
          },
        },
      ]
    },

    // フォームデータを設定
    setFormData(id) {
      // 編集の場合は既存のデータをコピー
      const info = this.infos.find(item => item.id === id)
      if (info) {
        this.formData = JSON.parse(JSON.stringify(info))
        // 日付をフォーマット
        this.formData.startAt = formatDateTime(this.formData.startAt, '-')
        this.formData.endAt = formatDateTime(this.formData.endAt, '-')
        return
      }

      // 新規作成の場合は空のフォームデータを作成
      this.formData = this.tableInit
      // 明日の12時を設定
      const tomorrow = new Date()
      tomorrow.setDate(tomorrow.getDate() + 1)
      tomorrow.setHours(12, 0, 0, 0)
      this.formData.startAt = formatDateTime(tomorrow, '-') // 明日の12時を設定
      // 1週間後の12時を設定
      const nextWeek = new Date()
      nextWeek.setDate(nextWeek.getDate() + 7)
      nextWeek.setHours(12, 0, 0, 0)
      this.formData.endAt = formatDateTime(nextWeek, '-')
    },

    // お知らせを保存（新規作成または更新）
    async saveInfo() {
      if (!this.formData) return

      try {
        const response = await apiService.post('/api/infos', this.formData)

        // 保存後に一覧を更新
        await this.getInfos()

        this.formData = null
        return response.message
      } catch (error) {
        return null
      }
    },

    // お知らせを削除
    async deleteInfo() {
      try {
        const response = await apiService.delete(`/api/infos/${this.formData.id}`)

        // 削除後に一覧を更新
        await this.getInfos()

        return response.message
      } catch (error) {
        return null
      }
    },

    // コピー時の処理
    onCopy() {
      this.formData.id = null
    },
  },
})
